"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RemixInjector = void 0;
const react_1 = require("react");
const jotai_1 = require("jotai");
const react_2 = require("@remix-run/react");
const utils_1 = require("jotai/utils");
const atom_1 = require("../../../atom");
const RemixInjector = () => {
    const store = (0, jotai_1.useStore)();
    const [search] = (0, react_2.useSearchParams)();
    const location = (0, react_2.useLocation)();
    (0, utils_1.useHydrateAtoms)([
        [atom_1.$SearchParams, search],
        [atom_1.$Location, location],
    ]);
    (0, react_1.useEffect)(() => {
        store.set(atom_1.$SearchParams, search);
    }, [store, search]);
    (0, react_1.useEffect)(() => {
        store.set(atom_1.$Location, location);
    }, [store, location]);
    return null;
};
exports.RemixInjector = RemixInjector;
